import { REMARK_STATUSES } from "../../../../../redux/modules/common/building/journal/journalExecution/types";

import { getOptionsFromEnum } from "../../../../../utils/formHelpers/getOptionsFromEnum";

export const REMARK_STATUSES_OPTIONS = getOptionsFromEnum(REMARK_STATUSES);
